import { render } from "./CommonSpaces.vue?vue&type=template&id=32467b38&scoped=true"
import script from "./CommonSpaces.vue?vue&type=script&lang=js"
export * from "./CommonSpaces.vue?vue&type=script&lang=js"

import "./CommonSpaces.vue?vue&type=style&index=0&id=32467b38&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32467b38"]])

export default __exports__